module.exports = __webpack_public_path__ + "img/club_02.5c162c84.png";